<template>
  <a-collapse activeKey="1" ghost>
    <a-collapse-panel key="1" header="内容" :show-arrow="false">
      <div class="rich-text-content" v-html="product_text.content"></div>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UsableProductText',
  props: {
    product_text: {
      type: Object,
      default: () => ({
        content: ''
      })
    }
  },
});
</script>

<style scoped></style>
